import styled from 'styled-components';

export const Switch = styled.div`
  display: inline-flex;
  align-items: center;
  flex: none;
  margin: 0 12px;
  padding: 2.595px;
  box-sizing: border-box;
  border-radius: 999px;
  background: #1c2224;
  border: 1px solid rgba(255, 255, 255, 0.1);
  box-shadow: inset 0 1px 3px rgba(0, 0, 0, 0.4);
`;

export const Option = styled.button`
  appearance: none;
  border: none;
  outline: none;
  cursor: pointer;
  padding: 6px 16px;
  border-radius: 999px;
  font: inherit;
  font-size: 14px;
  /* font-weight: 700; */
  line-height: 1.2;
  white-space: nowrap;
  color: #c9cfd3;
  background: transparent;
  transition: background 0.15s, color 0.15s, box-shadow 0.15s;

  &:hover {
    color: #fff;
  }

  &.active {
    cursor: default;
    color: #fff;
    background: linear-gradient(180deg, #58c882, #47b972);
    box-shadow: 0 0 12px rgba(71, 185, 114, 0.45);
  }
`;
